/* eslint-disable jsx-a11y/label-has-for */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DateTimeInput from './DateTimeInput';

export default class DateInputForRecurrence extends Component {
  static propTypes = {
    defaultValue: PropTypes.string,
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    recurrenceField: PropTypes.string.isRequired,
    useTimezone: PropTypes.string.isRequired,
  }

  static defaultProps = {
    defaultValue: '',
  }

  constructor(props) {
    super(props);

    const date = this.props.defaultValue;
    let visibility = false;
    let increment = { days: 0 };
    [visibility, increment] = this.checkRecurrence($(this.props.recurrenceField).val());

    this.state = { date, increment, visibility };
  }

  componentDidMount() {
    if (this.props.recurrenceField !== null) {
      $(document).on('change', this.props.recurrenceField, this.handleRecurrenceChange);
    }
    $(document).on('datetimeinput:change', this.handleStartDateChange);
  }

  componentWillUnmount() {
    $(document).off('change', this.props.recurrenceField, this.handleRecurrenceChange);
    $(document).off('datetimeinput:change', this.handleStartDateChange);
  }

  handleStartDateChange = (_, startDate, triggerName) => {
    if (startDate !== null) {
      // Remove the listener and exit if the triggered input was this input
      if (triggerName === this.props.name) {
        $(document).off('datetimeinput:change', this.handleStartDateChange);
        return;
      }
      const date = moment.tz(startDate, this.props.useTimezone).add(this.state.increment).format();
      this.setState({ date, startDate });
    }
  }

  handleDateChange = (newDate) => {
    this.setState({ date: moment.tz(newDate, this.props.useTimezone).format() });
  }

  checkRecurrence(value) {
    let increment = 0;
    let visibility = false;
    switch (value) {
      case 'false':
        visibility = false;
        break;
      case 'days':
        increment = { weeks: 1, days: -1 };
        visibility = true;
        break;
      case 'weeks':
        increment = { months: 1, days: -1 };
        visibility = true;
        break;
      case '2weeks':
        increment = { months: 2, days: -1 };
        visibility = true;
        break;
      case 'months':
        increment = { months: 3, days: -1 };
        visibility = true;
        break;
      default:
        break;
    }
    return [visibility, increment];
  }

  handleRecurrenceChange = (e) => {
    let visibility = false;
    let increment = 0;
    [visibility, increment] = this.checkRecurrence(e.target.value);
    const date = moment.tz(this.state.startDate, this.props.useTimezone).add(increment).format();
    this.setState({ visibility, increment, date });
  }

  render() {
    const style = { display: this.state.visibility ? 'block' : 'none' };
    return (
      <div style={style}>
        <label>{this.props.label}</label>
        <DateTimeInput
          name={this.props.name}
          defaultValue={this.state.date}
          time={false}
          onChange={this.handleDateChange}
          useTimezone={this.props.useTimezone}
        />
      </div>
    );
  }
}
